import React, { useCallback } from 'react';
import { type RouteProps, BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { Layout } from '../layout/Layout';
import { NAVIGATION_LINKS } from '../../shared/constants';
import { settingsManager } from '../../shared/settings';
import { OrganizationsPage, LeaveOrganizationsPage, DevicesPage, SettingsAndPrivacyPage, GroupsPage } from '../pages';
import { ConnectedAccountHome } from '../../Account/AccountHome';
import { Consent } from '../../TermsOfUse/Consent/Consent';
import { MyAcceptances } from '../../TermsOfUse/Acceptances/MyAcceptances';

export const Routes: React.FC = () => {
  const routeRender = useCallback(
    (props: RouteProps) => (
      <Layout {...props}>
        <Switch>
          {/* no lazy loading for AccountHome page because this's the most using page */}
          <Route path={`${NAVIGATION_LINKS.overview.link}`} exact component={ConnectedAccountHome} />
          <Route path={`${NAVIGATION_LINKS.devices.link}`} exact component={DevicesPage} />
          <Route path={`${NAVIGATION_LINKS.organizations.link}`} exact component={OrganizationsPage} />
          <Route
            path={`${NAVIGATION_LINKS.organizations.subRoutePaths!.leave.link}/:tenantId`}
            exact
            component={LeaveOrganizationsPage}
          />
          <Route path={`${NAVIGATION_LINKS.settingsAndPrivacy.link}`} component={SettingsAndPrivacyPage} />
          {settingsManager.get('isNewMyGroupsEnabled') && (
            <Route path={`${NAVIGATION_LINKS.groups.link}`} component={GroupsPage} />
          )}
          <Route path={`${NAVIGATION_LINKS.termsOfUse.subRoutePaths!.consent.link}`} component={Consent} />
          <Route path={`${NAVIGATION_LINKS.termsOfUse.subRoutePaths!.myAcceptances.link}`} component={MyAcceptances} />
          <Redirect to={NAVIGATION_LINKS.overview.link} />
        </Switch>
      </Layout>
    ),
    [],
  );

  return (
    <BrowserRouter>
      <Route render={routeRender} />
    </BrowserRouter>
  );
};
